import initialState from './initialState';

export function ruleProductListHasErrored(
  state = initialState.ruleProductListHasErrored,
  action,
) {
  switch (action.type) {
    case 'RULE_PRODUCT_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function ruleProductListIsLoading(
  state = initialState.ruleProductListIsLoading,
  action,
) {
  switch (action.type) {
    case 'RULE_PRODUCT_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function ruleProductListFetchDataSuccess(
  state = initialState.ruleProductListFetchDataSuccess,
  action,
) {
  switch (action.type) {
    case 'RULE_PRODUCT_LIST_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function newRuleProductSaveErrored(
  state = initialState.newRuleProductSaveErrored,
  action,
) {
  switch (action.type) {
    case 'NEW_RULE_PRODUCT_SAVE_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function nnewRuleProductIsSaving(
  state = initialState.nnewRuleProductIsSaving,
  action,
) {
  switch (action.type) {
    case 'NEW_RULE_PRODUCT_IS_SAVING':
      return action.isSaving;
    default:
      return state;
  }
}

export function newRuleProductSaveSuccess(
  state = initialState.newRuleProductSaveSuccess,
  action,
) {
  switch (action.type) {
    case 'NEW_RULE_PRODUCT_SAVE_SUCCESS':
      return action.isSavedSuccess;
    default:
      return state;
  }
}

export function deleteRuleProductHasErrored(
  state = initialState.deleteRuleProductHasErrored,
  action,
) {
  switch (action.type) {
    case 'DELETE_RULE_PRODUCT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function deleteRuleProductIsLoading(
  state = initialState.deleteRuleProductIsLoading,
  action,
) {
  switch (action.type) {
    case 'DELETE_RULE_PRODUCT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function deleteRuleProductSuccess(
  state = initialState.deleteRuleProductSuccess,
  action,
) {
  switch (action.type) {
    case 'DELETE_RULE_PRODUCT_SUCCESS':
      return action.items;
    default:
      return state;
  }
}
